import { paths } from "src/routes/paths";

import Iconify from "src/components/iconify";

// ----------------------------------------------------------------------
export const navConfig = [
  {
    title: "menu_sportproviders",
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: paths.sportproviders,
  },
  {
    title: "menu_sportmates",
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: paths.sportmates.root,
  },
  {
    title: "menu_tournaments",
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: paths.tournaments,
  },
  {
    title: "menu_sport_communities",
    icon: <Iconify icon="solar:users-group-rounded-bold-duotone" />,
    path: paths.sportCommunities,
  },
  // {

  // {
  //   title: "menu_forproviders",
  //   path: "#",
  //   icon: <Iconify icon="solar:file-bold-duotone" />,
  //   children: [
  //     {
  //       //        subheader: "menu_providers_options",
  //       subheader: "",
  //       items: [
  //         { title: "menu_coach", path: paths.partner_coach },
  //         { title: "menu_clubandcourt", path: paths.partner_clubandcourt },
  //         {
  //           title: "menu_tournament",
  //           path: paths.partner_tournament_organiser,
  //         },
  //         { title: "menu_player", path: paths.partner_player },
  //         // {
  //         //   title: "menu_program_for_people_with_disabilities",
  //         //   path: paths.partner_disabled_people_program,
  //         // },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   title: "menu_sportmates",
  //   icon: <Iconify icon="solar:home-2-bold-duotone" />,
  //   path: paths.sportmates.root,
  //   //path: "#",
  //   children: [
  //     {
  //       subheader: "",
  //       items: [
  //         {
  //           title: "introduction",
  //           path: paths.sportmates.landing,
  //         },

  //         {
  //           title: "subscription",
  //           path: paths.sportmates.root + "/?subscription=1",
  //         },
  //         {
  //           title: "menu_sportmates",
  //           path: paths.sportmates.root,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "menu_pricing",
  //   icon: <Iconify icon="solar:home-2-bold-duotone" />,
  //   path: paths.pricing,
  // },
  // {
  //   title: "menu_usermanual",
  //   icon: <Iconify icon="solar:atom-bold-duotone" />,
  //   path: paths.introduction,
  // },
  // {
  //   title: "Komponensek",
  //   icon: <Iconify icon="solar:atom-bold-duotone" />,
  //   path: paths.components,
  // },

  // {
  //   title: "Home",
  //   icon: <Iconify icon="solar:home-2-bold-duotone" />,
  //   path: "/",
  // },
  // {
  //   title: "menu_components",
  //   icon: <Iconify icon="solar:atom-bold-duotone" />,
  //   path: paths.components,
  // },
  // {
  //   title: "Foggo2 Komponensek",
  //   icon: <Iconify icon="solar:atom-bold-duotone" />,
  //   path: paths.custom_components,
  // },
  // {
  //   title: "Pages",
  //   path: "/pages",
  //   icon: <Iconify icon="solar:file-bold-duotone" />,
  //   children: [
  //     {
  //       subheader: "Other",
  //       items: [
  //         { title: "About us", path: paths.about },
  //         { title: "Contact us", path: paths.contact },
  //         { title: "FAQs", path: paths.faqs },
  //         { title: "Pricing", path: paths.pricing },
  //         { title: "Payment", path: paths.payment },
  //         { title: "Maintenance", path: paths.maintenance },
  //         { title: "Coming Soon", path: paths.comingSoon },
  //       ],
  //     },
  //     {
  //       subheader: "Concepts",
  //       items: [
  //         { title: "Shop", path: paths.product.root },
  //         { title: "Product", path: paths.product.demo.details },
  //         { title: "Checkout", path: paths.product.checkout },
  //         { title: "Posts", path: paths.post.root },
  //         { title: "Post", path: paths.post.demo.details },
  //       ],
  //     },
  //     {
  //       subheader: "Auth Demo",
  //       items: [
  //         { title: "Login", path: paths.authDemo.classic.login },
  //         { title: "Register", path: paths.authDemo.classic.register },
  //         {
  //           title: "Forgot password",
  //           path: paths.authDemo.classic.forgotPassword,
  //         },
  //         { title: "New password", path: paths.authDemo.classic.newPassword },
  //         { title: "Verify", path: paths.authDemo.classic.verify },
  //         { title: "Login (modern)", path: paths.authDemo.modern.login },
  //         { title: "Register (modern)", path: paths.authDemo.modern.register },
  //         {
  //           title: "Forgot password (modern)",
  //           path: paths.authDemo.modern.forgotPassword,
  //         },
  //         {
  //           title: "New password (modern)",
  //           path: paths.authDemo.modern.newPassword,
  //         },
  //         { title: "Verify (modern)", path: paths.authDemo.modern.verify },
  //       ],
  //     },
  //     {
  //       subheader: "Error",
  //       items: [
  //         { title: "Page 403", path: paths.page403 },
  //         { title: "Page 404", path: paths.page404 },
  //         { title: "Page 500", path: paths.page500 },
  //       ],
  //     },
  //     {
  //       subheader: "Dashboard",
  //       items: [{ title: "Dashboard", path: PATH_AFTER_LOGIN }],
  //     },
  //   ],
  // },
  // {
  //   title: "Docs",
  //   icon: <Iconify icon="solar:notebook-bold-duotone" />,
  //   path: paths.docs,
  // },
];
